module.exports = __webpack_public_path__ + "static/media/normal200h.09b3b1b6.png";